import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { DATA_GA_ID_KEY, DATA_GA_NAME_KEY } from './gaConstants';
import styles from './HpRespShopByModuleItem.scss';
import { slugify } from '../../utils/slugify';

function HpRespShopByModuleItem({ item, gaDataAttrs, className, isTopRow, onClick }) {
    const classNames = classnames(
        styles.wrapper,
        {
            [styles.topRow]: isTopRow,
            [styles.bottomRow]: !isTopRow,
        },
        className
    );

    if (!item.title || !item.link) {
        return null;
    }

    return (
        <div className={classNames} {...gaDataAttrs} data-tn={slugify(item.title)}>
            <a href={item.link} className={styles.link} onClick={onClick}>
                <div
                    className={styles.background}
                    style={{ backgroundImage: `url(${item.imageUrl})` }}
                >
                    <span className={styles.title}>{item.title}</span>
                </div>
            </a>
        </div>
    );
}

HpRespShopByModuleItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.string,
        imageUrl: PropTypes.string,
    }).isRequired,
    gaDataAttrs: PropTypes.shape({
        [DATA_GA_ID_KEY]: PropTypes.string.isRequired,
        [DATA_GA_NAME_KEY]: PropTypes.string.isRequired,
    }),
    className: PropTypes.string,
    isTopRow: PropTypes.bool,
    onClick: PropTypes.func,
};

HpRespShopByModuleItem.defaultProps = {
    onClick: () => {},
};

export { HpRespShopByModuleItem };
